import { render, staticRenderFns } from "./lg-marquee.vue?vue&type=template&id=c481dbfc&scoped=true&"
import script from "./lg-marquee.vue?vue&type=script&lang=js&"
export * from "./lg-marquee.vue?vue&type=script&lang=js&"
import style0 from "./lg-marquee.vue?vue&type=style&index=0&id=c481dbfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c481dbfc",
  null
  
)

export default component.exports